export default "__VITE_ASSET__42665a23__"